import { StrictMode, useEffect } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { createClient } from '@supabase/supabase-js'

const supabase = createClient(
  import.meta.env.VITE_PUBLIC_SUPABASE_URL,
  import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY
);

// Uygulama başlangıcında oturum kontrolü
supabase.auth.getSession().then(({ data: { session }, error }) => {
  if (error) {
    console.error('Session error:', error);
    // Hatalı oturumu temizle
    supabase.auth.signOut();
  }
});

// Oturum değişikliklerini dinle
supabase.auth.onAuthStateChange((event, session) => {
  if (event === 'TOKEN_REFRESHED') {
    console.log('Token refreshed successfully');
  }
  if (event === 'SIGNED_OUT') {
    console.log('User signed out');
  }
  if (event === 'USER_UPDATED') {
    console.log('User updated');
  }
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
